import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, isRef as _isRef, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9c2564a2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "on-monitor" }
const _hoisted_2 = { class: "second-room" }
const _hoisted_3 = { class: "container" }
const _hoisted_4 = { class: "crumbs" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "新闻中心", -1))
const _hoisted_6 = { class: "main" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "list" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = ["src"]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "tips" }, "NEW", -1))
const _hoisted_12 = { class: "time" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "to-detail" }, [
  /*#__PURE__*/_createTextVNode("查看详情"),
  /*#__PURE__*/_createElementVNode("i", { class: "arrow-right" })
], -1))
const _hoisted_14 = ["onClick"]
const _hoisted_15 = ["src"]
const _hoisted_16 = { class: "time" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "to-detail" }, [
  /*#__PURE__*/_createTextVNode("查看详情"),
  /*#__PURE__*/_createElementVNode("i", { class: "arrow-right" })
], -1))
const _hoisted_18 = {
  key: 1,
  class: "empet-list"
}
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://bazhuaedu.oss-cn-shanghai.aliyuncs.com/edu/Official/public/empty.png",
  alt: "暂无数据"
}, null, -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "暂无数据", -1))
const _hoisted_21 = [
  _hoisted_19,
  _hoisted_20
]
const _hoisted_22 = { class: "year" }
const _hoisted_23 = { class: "year-list" }
const _hoisted_24 = ["onClick"]
const _hoisted_25 = {
  key: 2,
  class: "find-more"
}
const _hoisted_26 = { key: 1 }
const _hoisted_27 = { class: "on-mobile" }
const _hoisted_28 = { class: "phone-news-tab-list" }
const _hoisted_29 = ["onClick"]
const _hoisted_30 = { class: "news-list" }
const _hoisted_31 = {
  key: 0,
  class: "container"
}
const _hoisted_32 = ["src"]
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "tips" }, "NEW", -1))
const _hoisted_34 = { class: "time" }
const _hoisted_35 = ["onClick"]
const _hoisted_36 = { class: "fl" }
const _hoisted_37 = { class: "time" }
const _hoisted_38 = ["src"]
const _hoisted_39 = {
  key: 1,
  class: "empet-list"
}
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://bazhuaedu.oss-cn-shanghai.aliyuncs.com/edu/Official/public/empty.png",
  alt: "暂无数据"
}, null, -1))
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "暂无数据", -1))
const _hoisted_42 = [
  _hoisted_40,
  _hoisted_41
]
const _hoisted_43 = {
  key: 2,
  class: "find-more"
}
const _hoisted_44 = { key: 1 }

import { useRouter } from "vue-router";
import { newsTypeListHttp, newsListHttp, yearListHttp } from "@/request/api";
import { ref,nextTick } from 'vue';
// 目录点击跳转路由事件
interface firstConfig {
    id: string|number;
    imgUrl: string;
    title: string;
    publishTime: string;
    description: string;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'list',
  setup(__props) {

// 引入useRouter
const router = useRouter();

const toPage = (name:string)=>{
    router.push({name});
}
const typeList = ref([] as any[]); // 新闻分类
// 获取新闻分类
newsTypeListHttp().then((res:any)=>{
    let {page} = res;
    let {list} = page;
    typeList.value = list;
})
let yearList = ref([]); // 年份列表
// 获取年份列表
yearListHttp().then((res:any)=>{
    let {years} = res;
    yearList.value = years;
})

let currentType = ref<any>(""); // 当前分类ID
let currentActive = ref(true); // 当前分类ID
let showFirstNews = ref(false); // 显示第一条新闻
let newsList = ref([] as any[]); // 新闻列表
let currentSearch = ref(""); // 搜索内容
let currentYear = ref(""); // 当前年份
let currentYearSort = ref(0); // 当前年份索引（用于动效）
let currentPage = ref(1); // 当前页码
let currentLimit = ref(6); // 当前每页条数
let hasMore = ref(true); // 是否还有更多
let firstNews = ref<firstConfig>({
    id: '',
    imgUrl: '',
    title: '',
    publishTime: '',
    description: '',
});

// 重置
const resetParams = ()=>{
    currentSearch.value = "";
    currentType.value = "";
    currentYear.value = "";
    currentYearSort.value = 0;
    currentPage.value = 1;
    currentLimit.value = 6;
}
// 获取新闻列表
const getNewsList = (flag?:boolean)=>{
    newsListHttp({
        title: currentSearch.value,
        newsType: currentType.value,
        page: currentPage.value,
        limit: currentLimit.value,
        year: currentYear.value
    }).then((res:any)=>{
        let {page} = res;
        let {list,pageSize} = page;
        if(currentType.value === "" && currentYear.value === "" && currentSearch.value === ""){
            showFirstNews.value = true;
            firstNews.value = res.new;
        }else{
            showFirstNews.value = false;
            firstNews.value = {
                id: '',
                imgUrl: '',
                title: '',
                publishTime: '',
                description: '',};
        }
        let arr = flag ? [] : newsList.value; // 是否重置获取
        newsList.value = arr.concat(list);
        hasMore.value =  list.length == pageSize;
    })
}
// 当前路由信息
let {query} = router.currentRoute.value;
let {type} = query;
// 进页面时初始化列表
currentType.value = type === undefined ? "" : type;
getNewsList(true);

// 点击新闻类型更新新闻列表
const updateNewsList = (type:number, d:string|any, index?:number)=>{
    showFirstNews.value = false;
    resetParams();
    switch(type){
        case 1:
            currentType.value = d;
            currentActive.value = true;
            break;
        case 2:
            currentSearch.value = d.target.value;
            currentActive.value = false;
            break;
        case 3:
            currentYear.value = d;
            currentYearSort.value = index || 0;
            currentActive.value = false;
            break;
        default:
            break;
    }
    nextTick(()=>{
        getNewsList(true);
    })
}
// 点击查看详情
const toDetail = (id:string|number)=>{
    if(id) {
        router.push({name:"newsDetail",query:{id,type: currentType.value}});
    }
}
// 点击查看更多
const findMore = ()=>{
    if(hasMore.value){
        currentPage.value += 1;
        nextTick(()=>{
            getNewsList();
        })
    }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("section", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("p", _hoisted_4, [
            _createElementVNode("span", {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (toPage('octopus')))
            }, "首页"),
            _hoisted_5
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("ul", null, [
              _createElementVNode("li", {
                class: _normalizeClass({active: _unref(currentType) == '' && _unref(currentActive)}),
                onClick: _cache[1] || (_cache[1] = ($event: any) => (updateNewsList(1,'')))
              }, "全部新闻", 2),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(typeList.value, (item, index) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: index,
                  class: _normalizeClass({active: _unref(currentType) == item.id}),
                  onClick: ($event: any) => (updateNewsList(1,item.id))
                }, _toDisplayString(item.name), 11, _hoisted_7))
              }), 128))
            ]),
            _createElementVNode("article", _hoisted_8, [
              (_unref(newsList) && _unref(newsList).length>0)
                ? (_openBlock(), _createElementBlock("ol", _hoisted_9, [
                    (_unref(showFirstNews))
                      ? (_openBlock(), _createElementBlock("li", {
                          key: 0,
                          class: "first-news",
                          onClick: _cache[2] || (_cache[2] = ($event: any) => (toDetail(_unref(firstNews).id)))
                        }, [
                          _createElementVNode("img", {
                            src: _unref(firstNews).imgUrl
                          }, null, 8, _hoisted_10),
                          _createElementVNode("div", null, [
                            _createElementVNode("h1", null, _toDisplayString(_unref(firstNews).title), 1),
                            _hoisted_11,
                            _createElementVNode("span", _hoisted_12, _toDisplayString(_unref(firstNews).publishTime), 1),
                            _createElementVNode("p", null, _toDisplayString(_unref(firstNews).description), 1),
                            _hoisted_13
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(newsList), (item, index) => {
                      return (_openBlock(), _createElementBlock("li", {
                        key: index,
                        onClick: ($event: any) => (toDetail(item.id))
                      }, [
                        _createElementVNode("img", {
                          src: item.imgUrl+''
                        }, null, 8, _hoisted_15),
                        _createElementVNode("h1", null, _toDisplayString(item.title), 1),
                        _createElementVNode("p", null, _toDisplayString(item.description), 1),
                        _createElementVNode("span", _hoisted_16, _toDisplayString(item.publishTime), 1),
                        _hoisted_17
                      ], 8, _hoisted_14))
                    }), 128))
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_18, _hoisted_21)),
              _createElementVNode("div", _hoisted_22, [
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  placeholder: "请输入",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_isRef(currentSearch) ? (currentSearch).value = $event : currentSearch = $event)),
                  onKeydown: _cache[4] || (_cache[4] = _withKeys(($event: any) => (updateNewsList(2, $event)), ["enter","native"]))
                }, null, 544), [
                  [_vModelText, _unref(currentSearch)]
                ]),
                _createElementVNode("div", _hoisted_23, [
                  (_unref(currentYearSort)>0)
                    ? (_openBlock(), _createElementBlock("i", {
                        key: 0,
                        class: "line",
                        style: _normalizeStyle('top:'+_unref(currentYearSort)*44+'px')
                      }, null, 4))
                    : _createCommentVNode("", true),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(yearList), (item, index) => {
                    return (_openBlock(), _createElementBlock("p", {
                      key: index,
                      class: _normalizeClass({active: _unref(currentYear) == item }),
                      onClick: ($event: any) => (updateNewsList(3, item, index+1))
                    }, _toDisplayString(item), 11, _hoisted_24))
                  }), 128))
                ])
              ]),
              (_unref(newsList) && _unref(newsList).length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                    (_unref(hasMore))
                      ? (_openBlock(), _createElementBlock("span", {
                          key: 0,
                          onClick: findMore,
                          class: "more"
                        }, "查看更多"))
                      : (_openBlock(), _createElementBlock("span", _hoisted_26, "没有更多了"))
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_27, [
      _createElementVNode("ul", _hoisted_28, [
        _createElementVNode("li", {
          class: _normalizeClass({active: _unref(currentType) == '' && _unref(currentActive)}),
          onClick: _cache[5] || (_cache[5] = ($event: any) => (updateNewsList(1,'')))
        }, "全部新闻", 2),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(typeList.value, (item, index) => {
          return (_openBlock(), _createElementBlock("li", {
            key: index,
            class: _normalizeClass({active: _unref(currentType) == item.id}),
            onClick: ($event: any) => (updateNewsList(1,item.id))
          }, _toDisplayString(item.name), 11, _hoisted_29))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_30, [
        (_unref(newsList) && _unref(newsList).length>0)
          ? (_openBlock(), _createElementBlock("ol", _hoisted_31, [
              (_unref(showFirstNews))
                ? (_openBlock(), _createElementBlock("li", {
                    key: 0,
                    class: "first-news",
                    onClick: _cache[6] || (_cache[6] = ($event: any) => (toDetail(_unref(firstNews).id)))
                  }, [
                    _createElementVNode("img", {
                      src: _unref(firstNews).imgUrl
                    }, null, 8, _hoisted_32),
                    _createElementVNode("h1", null, _toDisplayString(_unref(firstNews).title), 1),
                    _hoisted_33,
                    _createElementVNode("span", _hoisted_34, _toDisplayString(_unref(firstNews).publishTime), 1)
                  ]))
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(newsList), (item, index) => {
                return (_openBlock(), _createElementBlock("li", {
                  class: "clearfix",
                  key: index,
                  onClick: ($event: any) => (toDetail(item.id))
                }, [
                  _createElementVNode("div", _hoisted_36, [
                    _createElementVNode("h1", null, _toDisplayString(item.title), 1),
                    _createElementVNode("span", _hoisted_37, _toDisplayString(item.publishTime), 1)
                  ]),
                  _createElementVNode("img", {
                    class: "fr",
                    src: item.imgUrl+''
                  }, null, 8, _hoisted_38)
                ], 8, _hoisted_35))
              }), 128))
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_39, _hoisted_42)),
        (_unref(newsList) && _unref(newsList).length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
              (_unref(hasMore))
                ? (_openBlock(), _createElementBlock("span", {
                    key: 0,
                    onClick: findMore,
                    class: "more"
                  }, "查看更多"))
                : (_openBlock(), _createElementBlock("span", _hoisted_44, "没有更多了"))
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ], 64))
}
}

})